export default __webpack_public_path__ + "static/media/subscription_about_img.12152aa3.png";